const PUBLIC_MESSAGES = Object.freeze({
  validation: "Confira os dados informados.",
  credentials: "E-mail ou senha inválidos.",
  code: "Não foi possível confirmar este código.",
  rate_limit: "Muitas tentativas. Aguarde para tentar novamente.",
  unavailable: "Serviço temporariamente indisponível.",
  incompatible: "A confirmação por e-mail ainda não está disponível neste servidor.",
  network: "Não foi possível conectar. Verifique sua conexão.",
});

export class AuthServiceError extends Error {
  constructor(category, { status = null, retryAfter = null } = {}) {
    super(PUBLIC_MESSAGES[category]);
    this.name = "AuthServiceError";
    this.category = category;
    this.status = status;
    this.retryAfter = retryAfter;
  }
}

export const incompatibleAuthServerError = () => new AuthServiceError("incompatible");

const retryAfterHeader = (headers) => {
  if (!headers) return null;
  if (typeof headers.get === "function") return headers.get("retry-after");
  return headers["retry-after"] ?? headers["Retry-After"] ?? null;
};

const parseRetryAfter = (headers) => {
  const value = retryAfterHeader(headers);
  if (value === null || value === undefined || value === "") return null;

  const seconds = Number(value);
  if (Number.isFinite(seconds)) return Math.max(0, Math.ceil(seconds));

  const deadline = Date.parse(value);
  if (Number.isNaN(deadline)) return null;
  return Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
};

export const normalizeAuthError = (error, operation) => {
  if (error instanceof AuthServiceError) return error;

  const status = error?.response?.status ?? null;
  const retryAfter = parseRetryAfter(error?.response?.headers);
  let category;

  if (!error?.response) category = "network";
  else if (status === 422) category = "validation";
  else if (status === 401) category = operation === "start" ? "credentials" : "code";
  else if (status === 409) category = "code";
  else if (status === 429) category = "rate_limit";
  else category = "unavailable";

  return new AuthServiceError(category, { status, retryAfter });
};
